import React from "react";
import { Link, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import FormControl from "@material-ui/core/FormControl";
import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import BaseButton from "components/UI/Buttons/BaseButton";
import Paper from "@material-ui/core/Paper";
import AppLogo from "assets/avantor-logo.png";
import { styles } from "./SignInForm.styles";
import * as routes from "constants/routes";

class SignInForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.INITIAL_STATE = {
      email: "",
      password: ""
    };

    this.state = { ...this.INITIAL_STATE };
  }

  handleChange = e => {
    e.preventDefault();
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  handleSubmit = e => {
    e.preventDefault();

    const { email, password } = this.state;
    const { signInAction } = this.props;

    signInAction({ email, password }).then(() =>
      this.setState({ ...this.INITIAL_STATE })
    );
  };

  render() {
    const { email, password } = this.state;
    const { classes, auth, authError } = this.props;

    const isInvalid = password === "" || email === "";

    if (auth.uid) return <Redirect to="/" />;

    return (
      <div className={classes.wrapper}>
        <main className={classes.main}>
          <Paper className={classes.paper}>
            <img className={classes.appLogo} src={AppLogo} alt="avantor" />
            <Typography component="h1" variant="subtitle1">
              Sign In to your Account
            </Typography>
            <form className={classes.form} onSubmit={this.handleSubmit}>
              <FormControl margin="normal" required fullWidth>
                <TextField
                  name="email"
                  type="email"
                  label="Email"
                  autoComplete="email"
                  value={email}
                  onChange={this.handleChange}
                  variant="outlined"
                  autoFocus
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </FormControl>
              <FormControl margin="normal" required fullWidth>
                <TextField
                  name="password"
                  type="password"
                  label="Password"
                  autoComplete="current-password"
                  value={password}
                  onChange={this.handleChange}
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </FormControl>
              <BaseButton
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                disabled={isInvalid}
              >
                Sign in
              </BaseButton>

              {authError && <p style={{ color: "red" }}>{authError}</p>}
            </form>

            <div className={classes.section}>
              <Typography component="h6" variant="caption">
                New User? <Link to={routes.SIGN_UP}>Create an Account</Link>
              </Typography>
            </div>
          </Paper>
        </main>
      </div>
    );
  }
}

SignInForm.propTypes = {
  classes: PropTypes.object.isRequired,
  signInAction: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  authError: PropTypes.any
};

export default withStyles(styles)(SignInForm);
